import Component from './Alert.vue';

export default {
  install(Vue) {
    Vue.component('BkfAlert', Component);
  },
};
